import { createFileRoute } from '@tanstack/react-router'
import {
  useGetDefaultOrgSite,
  useSelectedOrgAndSiteInterface,
  // eslint-disable-next-line boundaries/dependencies
} from 'features/orgAndSiteSourceOfTruth'
import isNil from 'lodash/isNil'
import { AssetDatabase } from 'pages/assetDatabase/AssetDatabase'
// TODO: ARCH-529
import { assetDBSearchSchema, assetViewSchema } from 'types'

export const Route = createFileRoute('/assets/')({
  component: RouteComponent,
  staticData: {
    title: 'Assets',
  },
  // Single-asset pages carry their own `view` (e.g. 'details') back through
  // the Assets breadcrumb; anything that isn't a list view falls back to Scans.
  validateSearch: assetDBSearchSchema.extend({
    view: assetViewSchema.optional().catch(undefined),
  }),
})

function RouteComponent() {
  const searchParams = Route.useSearch()

  const { siteId, orgId, view, ...restOfSearchParams } = searchParams

  const defaultOrgSite = useGetDefaultOrgSite()
  const { setOrgAndSiteIds } = useSelectedOrgAndSiteInterface()

  if (!isNil(siteId)) {
    return (
      <AssetDatabase
        siteID={siteId}
        orgID={orgId}
        view={view}
        searchParams={restOfSearchParams}
      />
    )
  }

  if (defaultOrgSite.isLoading || defaultOrgSite.hasError) {
    return null
  }

  setOrgAndSiteIds(
    {
      siteId: defaultOrgSite.siteId,
      organizationId: defaultOrgSite.organizationId,
    },
    false
  )

  return (
    <>
      <AssetDatabase
        siteID={defaultOrgSite.siteId}
        orgID={defaultOrgSite.organizationId}
        view={view}
        searchParams={restOfSearchParams}
      />
    </>
  )
}
